import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_API_KEY = '/legalMatter/summary';

const emptySummary: Api.ILegalMatterSummary = {
	totalMatters: 0,
	openMatters: 0,
	closedMatters: 0,
};

export const useLegalMatterSummaryQuery = ({
	filterRequest,
	enabled,
	refetchOnWindowFocus = false,
}: {
	filterRequest: Api.ILegalMatterFilterRequest;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			const value = await userSession.webServiceHelper.callAsync<Api.ILegalMatterSummary>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'LegalMatter/summary',
				}),
				'POST',
				filterRequest
			);
			return value ?? emptySummary;
		},
		queryKey: [BASE_API_KEY, filterRequest],
		refetchOnWindowFocus,
	});
};

export const invalidateLegalMatterSummary = ({ filterRequest }: { filterRequest: Api.ILegalMatterFilterRequest }) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY, filterRequest] });
};

export const invalidateAllLegalMatterSummary = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY] });
};
